module.exports = __webpack_public_path__ + "img/dynamic-24.90bba9e0.png";